import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["team"];
import "core-js/modules/es.function.name.js";
import React from 'react';
import { useTranslation } from 'react-i18next';
import { getTeamIcon, TEAM_ICONS } from 'utils/icons';
import Icon from 'components/Icon';
import { TooltipPill } from 'components/Pill';
export default function TeamPill(_ref) {
  var _team$teamType;
  var team = _ref.team,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var isManagedTeam = (team === null || team === void 0 ? void 0 : team.role) === 'manager';
  return /*#__PURE__*/React.createElement(TooltipPill, _extends({}, otherProps, {
    title: isManagedTeam ? t('managed_team') : undefined,
    icon: getTeamIcon(team.isSmartTeam),
    iconColor: ((_team$teamType = team.teamType) === null || _team$teamType === void 0 ? void 0 : _team$teamType.colour) || TEAM_ICONS.TEAM
  }), team.name, isManagedTeam && /*#__PURE__*/React.createElement(Icon, {
    dimmed: true,
    vAlign: true,
    name: "star",
    scale: 0.8,
    ml: "xxxs"
  }));
}